<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
                <div class="row" id="warea">
                    
                    <div class="col-12 m-record" id="moreRcd">
                        <div class="row nav-top">
                            <div class="col-12 ddavc"><span class="nav-back wt" id="backF" onclick="window.location.href='#/mine'"></span><span
                                    class="tfw-5 tf-18" id="MoreRCT">Transactions</span></div>
                        </div>
                        <div class="row">
                            <div class="col-12" id="dtaod">


                                <div class="row mr-0 mt-2 rowvac h72 myma" v-for="row in resultrec" :key="row.id">
                                    <div class="col-2 xtc"><span class="icon rcwal_s sel"></span></div>
                                    <div class="col-6">
                                        <div class="row xtl tfwr">
                                            <div class="col-12 tfcdb tf-14">{{row.reason}}</div>
                                            <div class="col-12 pt-1 tf-12">{{gettime(row.time)}}</div>
                                        </div>
                                    </div>
                                    <div class="col-4 xtr tf-18 tfcsdb tfw-5">
                                        <g>{{parseFloat(row.amount).toFixed(2)}}</g>
                                    </div>
                                </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="row" id="odrea"></div>
            <div class="row" id="footer">
                <div class="col-12 nav-bar adsob" id="adsob">
                    <div class="row">
                        <div class="col-3 pa-0">
                            <div class="navItem" id="moxht2b4u" onclick="home()">
                                <div class="xtc"><span class="icon home" id="home"></span></div>
                                <div class="xtc">Home</div>
                            </div>
                        </div>
                        <div class="col-3 pa-0">
                            <div class="navItem" id="raeiyf2m0" onclick="group()">
                                <div class="xtc"><span class="icon group" id="group"></span></div>
                                <div class="xtc">Invite</div>
                            </div>
                        </div>
                        <div class="col-3 pa-0">
                            <div class="navItem" id="sfrm6bvy" onclick="wallet()">
                                <div class="xtc"><span class="icon wallet" id="wallet"></span></div>
                                <div class="xtc">Recharge</div>
                            </div>
                        </div>
                        <div class="col-3 pa-0">
                            <div class="navItem sel" id="mcpnvd2my" onclick="my()">
                                <div class="xtc"><span class="icon my sel" id="my"></span></div>
                                <div class="xtc">My</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" id="opffp"></div>
            <div class="row" id="anof">
            </div>
            <div class="row" id="dta_ref"></div>
        </div>
    </div>
</section>
</template>

<script>
import axios from "axios";
export default {
  name: "dairyView",
  data() {
    return {
      username: null,
      resultrec:[]
    }

  },
  beforeCreate: function () {
    if (localStorage.getItem('username') == null) {
      this.$router.push({ name: 'login' });
    }

  },
  mounted: function () {
    this.getrec();
  },
  methods: {
    getrec() {
        this.username = localStorage.getItem('username');
        axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=transrecord&user=' + this.username).then((res) => {
                this.resultrec = res.data;
                console.log(this.resultrec);
            }).catch((err) => {
                console.log(err);
            })
    },
    gettime(time){
        var timeStamp=Date.parse(time);
        const date= new Date(timeStamp);
        var dateFormat =  date.getDate()+
           "/"+(date.getMonth()+1)+" "+date.getHours()+
           ":"+date.getMinutes()+":0"+date.getSeconds();
        return dateFormat;
    },
   
  
  

  }
}
</script>